//Material
import { Grid, Typography } from '@mui/material';

//Models
import { InvoicePaymentMethods } from "../../../../models/EnumEntity";

//Components
import { CardPayment, QrPayment, CashPayment, TransferPayment, CheckPayment, Box, TotalAmount } from '@arredo/reactjs-ui'

const PaymentMethods = ({ paymentMethods }) => {
    const renderPayment = (payment) => {
        switch (payment.type) {
            case InvoicePaymentMethods.Card:
                return <CardPayment {...payment} installmentId={payment.plan} paymentMethodType={InvoicePaymentMethods.Card} />;
            case InvoicePaymentMethods.TerminalQr:
                return <QrPayment {...payment} paymentMethodType={InvoicePaymentMethods.TerminalQr} />;
            case InvoicePaymentMethods.ChargeByBank:
            case InvoicePaymentMethods.Qr:
                return <QrPayment {...payment} paymentMethodType={InvoicePaymentMethods.Qr} />;
            case InvoicePaymentMethods.Link:
                return <QrPayment {...payment} paymentMethodType={InvoicePaymentMethods.Link} />;
            case InvoicePaymentMethods.GOcuotas:
                return <QrPayment {...payment} paymentMethodType={InvoicePaymentMethods.GOcuotas} />;
            case InvoicePaymentMethods.Check:
                return <CheckPayment {...payment} paymentMethodType={InvoicePaymentMethods.Check} />;
            case InvoicePaymentMethods.Transfer:
                return <TransferPayment {...payment} paymentMethodType={InvoicePaymentMethods.Transfer} />;
            default:
                return <CashPayment paymentMethodType={InvoicePaymentMethods.Cash} />;
        }
    }

    return (
        <Box header={<Grid container direction='column' size={12}>
            <Typography>
                Medios de pago
            </Typography>
        </Grid>}
        >
            <Grid size={12}>
                <Grid container spacing={1} direction='column'>

                    <Grid size={12}>
                        {
                            paymentMethods?.map((payment, index) => (
                                <Grid key={index} size={12}>
                                    {renderPayment(payment)}
                                    <TotalAmount totalAmount={payment.amount} />
                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
export default PaymentMethods;